<template>
  <div id="header" class="toolbar-container">
      <!-- Titles -->
      <section id="titles" :title="titleToolTip">
        <h1 id="title">{{ title }}<span v-if="dirty" class="unsaved" :title="unsavedTooltip">*</span></h1>
        <h2 id="subtitle">{{ subtitle }}</h2>
      </section>

      <!-- Actions -->
      <section id="actions">
        <span class="mode data-entry" :title="toolbarTooltip">{{ $t('data entry title') }}</span>
        <ul>
          <!-- Edit -->
          <li id="cut" :class="{icon: true , disabled: cutDisabled}">
            <h-link-button id="cutButton" title="cut title" @click="cut" :disabled="cutDisabled">
              <hubble-cut/>
            </h-link-button>
          </li>
          <li id="copy" :class="{icon: true , disabled: copyDisabled}">
            <h-link-button id="copyButton" title="copy title" @click="copy" :disabled="copyDisabled">
              <hubble-copy/>
            </h-link-button>
          </li>
          <li id="paste" :class="{icon: true , disabled: pasteDisabled}">
            <h-link-button id="pasteButton" title="paste title" @click="paste" :disabled="pasteDisabled">
              <hubble-paste/>
            </h-link-button>
          </li>
          <li id="clear" :class="{icon: true , disabled: clearDisabled}">
            <h-link-button id="clearButton" title="clear title" @click="clear" :disabled="clearDisabled">
              <hubble-clear/>
            </h-link-button>
          </li>
          <!-- Rows -->
          <li id="insert" v-if="canInsert" :class="{icon: true , disabled: insertDisabled}">
            <h-link-button id="insertButton" title="insert row title" :disabled="insertDisabled" @click="insert">
              <hubble-insert/>
            </h-link-button>
          </li>
          <li class="separator"></li>
          <!-- Management -->
          <li id="apply" v-if="saving" :class="{icon: true , disabled: saveDisabled}">
            <h-link-button id="applyButton" title="saving title" :disabled="saveDisabled" @click="saveAndContinue">
              <hubble-save/>
            </h-link-button>

          </li>
          <li id="apply" v-else :class="{icon: true , disabled: saveDisabled}" >
            <h-link-button id="applyButton" title="save title" :disabled="saveDisabled" @click="saveAndContinue">
              <hubble-save/>
            </h-link-button>
          </li>
          <li id="close" :class="{icon: true , disabled: closeDisabled}">
            <h-link-button id="closeButton" title="close title" :disabled="closeDisabled" @click="close">
              <hubble-close/>
            </h-link-button>
          </li>
        </ul>
      </section>
  </div>
</template>

<script>
import LinkButton from '@/components/common/Link-Button'
import utils from '@/utils'
import HubbleClose from '@/assets/icons/ui.svg?hubble-close'
import HubbleCut from '@/assets/icons/ui.svg?hubble-cut'
import HubbleCopy from '@/assets/icons/ui.svg?hubble-copy'
import HubblePaste from '@/assets/icons/ui.svg?hubble-paste'
import HubbleInsert from '@/assets/icons/ui.svg?hubble-insert'
import HubbleSave from '@/assets/icons/ui.svg?hubble-save'
import HubbleClear from '@/assets/icons/ui.svg?hubble-clear'

export default {
  components: {
    'h-link-button': LinkButton,
    'hubble-close': HubbleClose,
    'hubble-cut': HubbleCut,
    'hubble-copy': HubbleCopy,
    'hubble-paste': HubblePaste,
    'hubble-insert': HubbleInsert,
    'hubble-save': HubbleSave,
    'hubble-clear': HubbleClear
  },
  props: {
    canInsert: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    dirty: {
      type: Boolean,
      required: true
    },
    saveDisabled: {
      type: Boolean,
      required: true
    },
    closeDisabled: {
      type: Boolean,
      required: true
    },
    cutDisabled: {
      type: Boolean,
      required: true
    },
    copyDisabled: {
      type: Boolean,
      required: true
    },
    pasteDisabled: {
      type: Boolean,
      required: true
    },
    clearDisabled: {
      type: Boolean,
      required: true
    },
    insertDisabled: {
      type: Boolean,
      required: true
    },
    saving: {
      type: Boolean,
      required: true
    }

  },
  computed: {
    titleToolTip () {
      let tip = this.title
      if (this.subtitle) {
        tip += `\n${this.subtitle}`
      }
      return tip
    },
    unsavedTooltip () {
      return this.$i18n.translate('unsaved tooltip')
    },
    toolbarTooltip () {
      return this.$i18n.translate('toolbar tooltip')
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    saveAndContinue () {
      this.$emit('saveAndContinue')
    },
    copy () {
      this.$emit('copy')
    },
    insert () {
      this.$emit('insertrow')
    },
    paste () {
      this.$emit('paste')
    },
    clear () {
      this.$emit('clear')
    },
    cut () {
      this.$emit('cut')
    }
  }
}
</script>

<style scoped>
</style>
